<template lang="pug">
    el-dialog(:title="title", width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label {{ruleForm.matchType == '-1' ? '青少年赛' : '分级公开赛'}}
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                        div.width_label(v-if="ruleForm.ctType === 1") 常规赛
                        div.width_label(v-if="ruleForm.ctType === 2") 月度赛
                        div.width_label(v-if="ruleForm.ctType === 3") 季度赛
                        div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="比赛项目" prop="projectType")
                        div.width_label(v-if="ruleForm.projectType === 1") 单打
                        div.width_label(v-if="ruleForm.projectType === 2") 双打
                el-form-item(label="级别" prop="level")
                        div.width_label {{ruleForm.level}}
                el-form-item(label="签位" prop="applySize")
                        div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                br
                el-form-item(label="比赛时间")
                        div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
            el-row(style="padding-top:10px")
                el-col(:span="24")
                    el-button(type="primary" @click="exportExcel") 名单导出
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 参赛人员
                      div
                        el-table(:data="enrollDataOne" border)
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column(prop="mobile" label="会员账号" align='center' width="130")
                                el-table-column(prop="gender" label="性别" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="60")
                                el-table-column(prop="yearScore" label="积分" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                        font(v-if="!scope.row.yearScore") 0
                                el-table-column(prop="memberType" label="会员类型" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.memberType == 1") 注册会员
                                        font(v-if="scope.row.memberType == 2") 初始会员
                                        font(v-if="scope.row.memberType == 3") 荣誉会员
                                el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未缴费
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 已缴费
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount")
                                            span() ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null && scope.row.refundScale != 'Infinity'") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null && scope.row.refundFee != ''")
                                            span() ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
            el-row(style="padding-top:10px")
                el-col(:span="24")
                    el-button(type="primary" @click="orderExportExcel") 订单明细
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header")
                        font.font_label 订单详情
                        //- el-button.btn_style(type="primary" @click="orderExportExcel") 名单导出
                      div
                        el-table(:data="orderInfoData" border)
                                el-table-column(prop="orderUserName" label="姓名" align='center')
                                el-table-column(prop="account" label="会员账号" align='center')
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundAmount" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundAmount !== null") ￥{{parseFloat(scope.row.refundAmount).toFixed(2)}}元
                                el-table-column(prop="payStatus" label="状态" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0") 未支付
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 支付成功
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消

            //争议弹框
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import table from './tablect1.js'
import orderTable from './orderTable.js'

export default {
    data() {
        return {
            isCollapse: true,
            table: {
                columns: table.columns,
                data: null,
                size: 'mini',
                stripe: true,
                border: true
            },
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            memberName: '',
            buttonSize: 'large',
            options: [],
            value: '',
            visible: false,
            title: '参赛人员',
            enrollData: [],
            enrollDataOne: [],
            ruleForm: {
                id: '',
                ctId: '',
                matchName: '',
                orgId: '',
                city: '',
                province: '',
                placeId: '',
                ctType: '',
                applySize: '',
                projectType: null,
                level: '',
                bench: '1',
                applyDate: [],
                matchSignStartTime: '',
                matchSignEndTime: '',
                matchStartTime: '',
                imgList: '',
                gameDescription: '',
                matchDescription: '',
                imgDetailList: '',
                repeatSign: '0',
                genderLimit: '2',
                ageLimit: '',
                ageMinMen: undefined,
                ageMaxMen: undefined,
                ageMinWomen: undefined,
                ageMaxWomen: undefined,
                scoreMin: '',
                ctRefundList: [],
                byx1: '',
                verifyReason: '',
                orderForm: 1
            },
            loading: null,
            orderInfoData: [],
            type: '',
            busCategory:''
        }
    },
    methods: {
        init(id, type,busCategory) {
            this.ruleForm.id = id
            this.type = type
            this.busCategory = busCategory
            this.visible = true
            this.enrollData = []
            this.enrollDataOne = []

            //回显
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.ruleForm = data.bean
                    console.log('竞赛信息：', data.bean)
                    this.ruleForm.orderForm = 0
                    let joinCount = this.ruleForm.joinCount//已报名参赛人员的人数
                    let applySize = this.ruleForm.applySize//赛事签位数
                    let date1 = new Date().getTime()
                    let date2 = new Date(this.ruleForm.matchStartTime).getTime()
                    let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
                    let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
                    if (date1 < date3) {
                        this.ruleForm.statusName = '未开始'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount < applySize) {
                        this.ruleForm.statusName = '报名中'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount >= applySize && this.ruleForm.bench === 1) {
                        this.ruleForm.statusName = '报满可替'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount >= applySize && this.ruleForm.bench === 0) {
                        this.ruleForm.statusName = '已报满'
                    } else if (date1 > date4 && date1 < date2) {
                        this.ruleForm.statusName = '报名结束'
                    } else if (date1 >= date2) {
                        this.ruleForm.statusName = '已开赛'
                    }
                }
            }).then(() => {
                this.getEnrollData(id)
            }).then(() => {
                this.getInfoData()
            })
        },
        //列表刷新
        getEnrollData(id) {
            let params = { 'ctId': id }
            params.orderForm = 0
            this.$http({
                url: this.$http.adornUrl(`/elEnrollOrder/getByCtId`),
                method: 'post',
                params: this.$http.adornParams(params)
            }).then((data) => {
                if (data && data.code === 0) {
                    console.log('参赛人员列表：', data)
                    this.enrollData = data.list
                    this.table.data = data.list
                    this.enrollDataOne = []
                    for (let i of this.enrollData) {
                        if (i.refundScale === null && i.refundFee !== null) {
                            i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
                        }
                        if (i.refundFee === null && i.refundScale !== null) {
                            i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
                        }

                        if (i.bench === 0) {
                            //主力
                            this.enrollDataOne.push(i)
                        }
                    }
                }
            })
        },
        //导出excel
        exportExcel() {
            console.log('表头：', this.table.columns)
            let exportData = []
            console.log('表数据：', exportData)
            for (let i of this.table.data) {
                if (i.bench === 0) {
                    i.genderName = { 0: '男', 1: '女' }[i.gender]
                    i.memberTypeName = { '1': '注册会员', '2': '初始会员', '3': '荣誉会员' }[i.memberType]
                    i.yearScore = i.yearScore || 0
                    exportData.push(i)
                }
            }
            if (exportData == null || exportData.length === 0) {
                this.$message.info('没有要导出的数据!')
                return
            }
            let title = this.ruleForm.matchName || ''
            this.$export.excel({
                columns: this.table.columns,
                data: exportData,
                title: title + '参赛人员'
            }).then(() => {
                this.$message.success('导出表格成功')
            })
        },
        getInfoData() {
            this.$http({
                url: this.$http.adornUrl('/frFranchiseFeeRecord/queryCtPxOrderList'),
                method: 'post',
                data: {
                    busId: this.ruleForm.matchId,
                    ctPxId: this.ruleForm.id,
                    orderType: this.type,
                    busCategory:this.busCategory
                }
            }).then(res => {
                console.log(res)
                this.orderInfoData = res.data

            })
        },
        orderExportExcel() {
            this.$http({
                url: this.$http.adornUrl('/frFranchiseFeeRecord/exportCtPxOrderList'),
                method: 'post',
                data: {
                    busId: this.ruleForm.matchId,
                    ctPxId: this.ruleForm.id,
                    orderType: this.type,
                    busCategory:this.busCategory
                }
            }).then(data => {
                if (data && data.code === 0) {
                    if (data.list == null || data.list.length === 0) {
                        this.$message.info('没有要导出的数据!')
                        return
                    }
                    let exportData = data.list
                    this.$export.excel({
                        columns: orderTable.columns,
                        data: exportData,
                        title: '订单详情'
                    }).then(() => {
                        this.$message.success('导出表格成功')
                    })
                }

            })
        }
    }
}
</script>
<style>
.width_label {
    width: 180px;
}

.opSetting {
    text-align: center;
    margin-top: 30px;
}

.spacing {
    margin-top: 10px;
}

.font_label {
    font-weight: bold;
    font-size: 18px;
}

.el-radio.is-bordered {
    width: 140px;
    padding: 12px 20px 0 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 40px;
}

/* 分页样式 */
.el-pager li {
    padding: 0 4px;
    font-size: 13px;
    min-width: 20.5px;
    height: 28px;
    line-height: 28px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
}
</style>
